import { useEffect, useState } from "react";
import api from "@/lib/api";
import DashboardShell from "@/components/nav/DashboardShell";
import { useAuth } from "@/lib/auth";
import { toast } from "sonner";

export default function Settings() {
  const { user } = useAuth();
  const [biz, setBiz] = useState(null);

  useEffect(() => { api.get("/business").then(({data}) => setBiz(data)).catch(() => {}); }, []);

  const save = async (e) => {
    e.preventDefault();
    try {
      await api.patch("/business", biz);
      toast.success("Saved");
    } catch { toast.error("Failed"); }
  };

  if (!biz) return <DashboardShell><div className="text-smoke">Loading…</div></DashboardShell>;

  return (
    <DashboardShell>
      <div className="brand-eyebrow mb-4">ACCOUNT</div>
      <h1 className="brand-headline text-4xl md:text-6xl mb-8">Settings.</h1>

      <form onSubmit={save} className="max-w-2xl border border-line p-8">
        <div className="brand-eyebrow mb-6">BUSINESS</div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
          <div><label>Business name</label><input value={biz.name||""} onChange={e => setBiz({...biz, name: e.target.value})} /></div>
          <div><label>Industry</label><input value={biz.industry||""} onChange={e => setBiz({...biz, industry: e.target.value})} /></div>
          <div><label>Website</label><input value={biz.website||""} onChange={e => setBiz({...biz, website: e.target.value})} /></div>
          <div><label>Contact name</label><input value={biz.contact_name||""} onChange={e => setBiz({...biz, contact_name: e.target.value})} /></div>
          <div><label>Contact email</label><input value={biz.email||""} onChange={e => setBiz({...biz, email: e.target.value})} /></div>
          <div><label>Phone</label><input value={biz.phone||""} onChange={e => setBiz({...biz, phone: e.target.value})} /></div>
          <div className="col-span-full"><label>Timezone</label><input value={biz.timezone||""} onChange={e => setBiz({...biz, timezone: e.target.value})} /></div>
        </div>
        <button data-testid="settings-save" type="submit" className="btn-gold mt-8">Save changes</button>
      </form>

      <div className="max-w-2xl mt-10 border border-line p-8">
        <div className="brand-eyebrow mb-4">SIGNED IN AS</div>
        <div className="text-white text-lg">{user?.full_name}</div>
        <div className="text-smoke text-sm">{user?.email}</div>
      </div>
    </DashboardShell>
  );
}
